import React from 'react'
import { Link } from "react-router-dom";


const OurDoctor = () => {
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>Our Doctor</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item">Our Doctor</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>


            <section className="content-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover active">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img1.webp" alt="/" />
                                    <Link to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </Link>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Nashid Martines</a></h3>
                                        <span className="dz-position">Cardiac Surgery</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img2.webp" alt="/" />
                                    <a to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Danial Frankie</a></h3>
                                        <span className="dz-position">Pediatric Clinic</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img3.webp" alt="/" />
                                    <a to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Rihana Roy</a></h3>
                                        <span className="dz-position">Gynecology</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img4.webp" alt="/" />
                                    <a to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Kenneth Fong</a></h3>
                                        <span className="dz-position">Neurology</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img1.webp" alt="/" />
                                    <a to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Nashid Martines</a></h3>
                                        <span className="dz-position">Cardiac Surgery</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img2.webp" alt="/" />
                                    <a to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Danial Frankie</a></h3>
                                        <span className="dz-position">Pediatric Clinic</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.7s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img3.webp" alt="/" />
                                    <a to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Nashid Martines</a></h3>
                                        <span className="dz-position">Cardiac Surgery</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/images/team/img4.webp" alt="/" />
                                    <a to="/" className="btn btn-primary">
                                        <i className="feather icon-calendar m-r5" />
                                        Appointment Now
                                    </a>
                                </div>
                                <div className="dz-content">
                                    <div className="clearfix">
                                        <h3 className="dz-name"><a to="team-detail.html">Rihana Roy</a></h3>
                                        <span className="dz-position">Neurology</span>
                                    </div>
                                    <a to="team-detail.html" className="btn btn-square btn-secondary">
                                        <i className="feather icon-arrow-right" />
                                    </a>
                                </div>
                                <ul className="dz-social">
                                    <li>
                                        <a to="https://www.linkedin.com" target="_blank">
                                            <i className="fa-brands fa-linkedin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.instagram.com" target="_blank">
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.facebook.com" target="_blank">
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://twitter.com" target="_blank">
                                            <i className="fa-brands fa-x-twitter" />
                                        </a>
                                    </li>
                                    <li>
                                        <a to="https://www.youtube.com" target="_blank">
                                            <i className="fa-brands fa-youtube" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>

        </>
    )
}

export default OurDoctor